import { Model } from '@/clients/http'

import { SystemResponses } from '@/types'

export class SystemModel extends Model {
  public static readonly correlations = {
    GET_INFO: 'SYSTEM_GET_INFO',
  }

  public static readonly endpoints = {
    getInfo: () => '/api/backoffice/system-uid',
  }

  public static readonly getInfo = async (props?: { store?: boolean }) => {
    return this.createHttpRequest<SystemResponses.Info>({
      correlationKey: this.correlations.GET_INFO,
      payload: {
        method: 'get',
        url: this.endpoints.getInfo(),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
